export default function (receiver, functionName, ...args) {
  return receiver[functionName](...args.slice(0, -1));
}
